<template>
<div>
    <div class="nav-tabs-container pt-1" v-if="!hideTabs">
        <div class="nav-tabs-scroll-helper">
            <ul class="nav nav-tabs">

                <li class="nav-item">
                    <a class="nav-link" :class="{'active': mode == 'all'}" href id="tabLinkCompanyEarnings1" role="tab" aria-controls="tabContentCompanyEarnings1" :aria-selected="mode == 'all'" @click.prevent="mode = 'all'; $bus.$emit('resize')">
                        {{ allLabel || 'All Earning Types' }} ({{ allCount }})
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" :class="{'active': mode == 'selected'}" href id="tabLinkCompanyEarnings2" role="tab" aria-controls="tabContentCompanyEarnings2" :aria-selected="mode == 'selected'" @click.prevent="mode = 'selected'; $bus.$emit('resize')">
                        {{ selectedLabel || 'Selected' }} ({{ selectedCount }})
                    </a>
                </li>

            </ul>
        </div>
    </div>

    <div class="flex-body flex-container tab-content company-earning-type-selector">
        <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'all'}" id="tabContentCompanyEarnings1" role="tabpanel" aria-labelledby="tabLinkCompanyEarnings1">
            <fast-table
                v-if="mode == 'all'"
                :sections="sections"
                :headers="headers"
                :data="tableData"
                @click="onClick"
                @select="onSelect"
                :has-row-select="true"
                :show-search="!hideSearch"
                :show-filter="false"
                :show-more-actions="false"
            />
        </div>

        <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'selected'}" id="tabContentCompanyEarnings2" role="tabpanel" aria-labelledby="tabLinkCompanyEarnings2">
            <fast-table
                v-if="mode == 'selected'"
                :sections="sections"
                :headers="headers"
                :data="selectedTableData"
                @click="onClick"
                @select="onSelect"
                :has-row-select="true"
                :show-search="!hideSearch"
                :show-filter="false"
                :show-more-actions="false"
            />
        </div>
    </div>
</div>
</template>

<script>
import FastTable from '@/components/FastTable'

export default {
    props: ['modelValue', 'companyEarningTypes', 'hideSearch', 'hideTabs', 'allLabel', 'selectedLabel'],
    emits: ['update:modelValue'],
    components: {FastTable, },
    computed: {
        tableData() {
            const result = []

            this.sortedCompanyEarningTypes.forEach(cet => {
                result.push({
                    id: cet.id,
                    isSelected: this.formData.companyEarningTypes.includes(cet.id),
                    object: cet,
                    cells: [
                        cet.name,
                        cet.type_pretty,
                        this.treatment(cet),
                    ],
                })
            })

            return [result]
        },
        selectedTableData() {
            let result = this.tableData[0].filter(row => {
                return this.formData.companyEarningTypes.includes(row.object.id)
            })

            result = JSON.parse(JSON.stringify(result))
            result.forEach(row => {
                row.isSelected = true
            })

            return [result]
        },
        sortedCompanyEarningTypes() {
            const result = Array.from(this.companyEarningTypes || [])
            result.sort((a, b) => {
                if (a.sort_priority != b.sort_priority) {
                    return a.sort_priority - b.sort_priority
                }
                return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
            })
            return result
        },
        allCount() {
            return this.tableData[0].length
        },
        selectedCount() {
            return this.formData.companyEarningTypes.length
        },
    },
    data() {
        return {
            mode: 'all',
            formData: {
                companyEarningTypes: Array.from(this.modelValue || []),
            },
            sections: [
                {title: 'All', id: 'all'},
            ],
            headers: [
                {label: 'Earning Type', classes: '', defaultSort: true, isFilterable: false, isSearchable: true, },
                {label: 'Type', classes: '', defaultSort: false, isFilterable: true, isSearchable: false, },
                {label: 'Tax Treatment', classes: '', defaultSort: false, isFilterable: true, isSearchable: false, },
            ],
        }
    },
    watch: {
        modelValue(value) {
            this.formData.companyEarningTypes = Array.from(value || [])
        },
        companyEarningTypes() {
            this.$bus.$emit('resize')
        },
    },
    mounted() {
        this.$bus.$emit('resize')
    },
    methods: {
        treatment(cet) {
            // Surfaced because it is exactly what the choice turns on: tips count toward
            // a deferred comp basis, imputed income does not.
            if (cet.is_virtual) {
                return 'Imputed income'
            }
            if (cet.is_tips) {
                return 'Tips'
            }
            return 'Wages'
        },
        onSelect(rows) {
            const selected = new Set()
            rows.forEach(row => {
                selected.add(row.object.id)
            })

            this.formData.companyEarningTypes = Array.from(selected)

            this.$emit('update:modelValue', this.formData.companyEarningTypes)
        },
        onClick(companyEarningType) {
            if (this.formData.companyEarningTypes.includes(companyEarningType.id)) {
                this.formData.companyEarningTypes = this.formData.companyEarningTypes.filter(id => id != companyEarningType.id)
            }
            else {
                this.formData.companyEarningTypes.push(companyEarningType.id)
            }

            this.$emit('update:modelValue', this.formData.companyEarningTypes)
        },
    },
}
</script>

<style>
.company-earning-type-selector .table-wrapper {
    max-height: 320px;
    min-height: 280px;
}
</style>
